import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Check, ShieldCheck, Zap, Gift } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const sectionId = 'oferta';
  return <section id="oferta" className="py-16 md:py-32 bg-cream-100 relative overflow-hidden" data-id="element-272">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none" data-id="element-273">
        <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-sage-200/40 blur-3xl" data-id="element-274"></div>
        <div className="absolute bottom-[-20%] left-[-10%] w-[60%] h-[60%] rounded-full bg-coral-100/40 blur-3xl" data-id="element-275"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-276">
        <div className="bg-white rounded-[2.5rem] shadow-xl p-8 md:p-12 lg:p-16 border border-cream-200" data-id="element-277">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-278">
            {/* Image Side */}
            <FadeIn direction="right" data-id="element-279">
              <div className="relative mx-auto w-full max-w-sm lg:max-w-none" data-id="element-280">
                <div className="absolute inset-0 bg-sage-100 rounded-full blur-3xl opacity-60 transform scale-90" data-id="element-281"></div>
                <img src="https://cdn.magicpatterns.com/uploads/rzZNtrxzqEz2mimBwc3892/PROTOCOLO_ANTI-INFLAMATORIO_21D_Mockup.png" alt="Protocolo Anti-Inflamatorio 21D" className="relative z-10 w-full h-auto object-contain drop-shadow-xl" data-id="element-282" />
              </div>
            </FadeIn>

            {/* Content Side */}
            <FadeIn direction="left" delay={0.2} data-id="element-283">
              <div className="text-center lg:text-left" data-id="element-284">
                <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-285">
                  Recupera tu bienestar hoy mismo.
                </h2>

                <p className="text-lg text-charcoal-light mb-6 font-sans" data-id="element-286">
                  El Protocolo Anti-Inflamatorio 21D completo, incluyendo la
                  Guía de Rescate y el Checklist de Compras por un pago único.
                </p>

                <div className="bg-white/60 rounded-2xl p-5 mb-8 border border-cream-200 space-y-3 text-sm md:text-base text-left" data-id="element-287">
                  <div className="flex items-center justify-between gap-4" data-id="element-288">
                    <div className="flex items-center gap-2.5" data-id="element-289">
                      <Check className="w-5 h-5 text-sage-600 flex-shrink-0" data-id="element-290" />
                      <span className="font-bold text-charcoal" data-id="element-291">
                        Protocolo 21D
                      </span>
                    </div>
                    <span className="text-charcoal-light whitespace-nowrap" data-id="element-292">
                      $8.999
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-4" data-id="element-293">
                    <div className="flex items-center gap-2.5" data-id="element-294">
                      <Gift className="w-5 h-5 text-coral-400 flex-shrink-0" data-id="element-295" />
                      <span className="text-charcoal" data-id="element-296">
                        Bono #1: Día 0 Express
                      </span>
                    </div>
                    <span className="text-charcoal-light line-through whitespace-nowrap" data-id="element-297">
                      $15.667
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-4" data-id="element-298">
                    <div className="flex items-center gap-2.5" data-id="element-299">
                      <Gift className="w-5 h-5 text-coral-400 flex-shrink-0" data-id="element-300" />
                      <span className="text-charcoal" data-id="element-301">Bono #2: Semáforo</span>
                    </div>
                    <span className="text-charcoal-light line-through whitespace-nowrap" data-id="element-302">
                      $15.667
                    </span>
                  </div>
                  <div className="flex items-center justify-between gap-4" data-id="element-303">
                    <div className="flex items-center gap-2.5" data-id="element-304">
                      <Gift className="w-5 h-5 text-coral-400 flex-shrink-0" data-id="element-305" />
                      <span className="text-charcoal" data-id="element-306">
                        Bono #3: Rescate 10 Min
                      </span>
                    </div>
                    <span className="text-charcoal-light line-through whitespace-nowrap" data-id="element-307">
                      $15.666
                    </span>
                  </div>
                  <div className="pt-3 mt-3 border-t border-cream-200 flex items-center justify-between gap-4 font-bold" data-id="element-308">
                    <span className="text-charcoal" data-id="element-309">Valor Total</span>
                    <span className="text-coral-400 line-through whitespace-nowrap" data-id="element-310">
                      $55.999
                    </span>
                  </div>
                </div>

                <div className="bg-sage-50 rounded-2xl p-6 mb-8 border border-sage-100 inline-block w-full" data-id="element-311">
                  <span className="text-sm font-bold text-sage-600 uppercase tracking-wider mb-2 block" data-id="element-312">
                    Precio Especial de Lanzamiento
                  </span>
                  <div className="flex items-baseline justify-center lg:justify-start gap-2" data-id="element-313">
                    <span className="text-5xl md:text-6xl font-bold text-charcoal" data-id="element-314">
                      $8.999
                    </span>
                    <span className="text-xl text-charcoal-light font-sans" data-id="element-315">
                      ARS
                    </span>
                  </div>
                </div>

                <div id="oferta-cta" className="flex flex-col items-center lg:items-start gap-4" data-id="element-316">
                  <CTAButton className="w-full sm:w-auto" onClick={() => {
                  trackAddToCart();
                  window.open('https://www.saboressdevidaa.shop/cart/44833151221830:1', '_blank');
                }} data-id="element-317" />

                  <div className="flex flex-wrap justify-center lg:justify-start gap-4 mt-4 text-sm text-charcoal-light font-sans" data-id="element-318">
                    <div className="flex items-center gap-1.5" data-id="element-319">
                      <ShieldCheck className="w-4 h-4 text-sage-600" data-id="element-320" />
                      <span data-id="element-321">Pago seguro y cifrado</span>
                    </div>
                    <div className="flex items-center gap-1.5" data-id="element-322">
                      <Zap className="w-4 h-4 text-coral-500" data-id="element-323" />
                      <span data-id="element-324">Acceso inmediato</span>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}